export const folderEPrescriptionsPageTableFrag = `
    id
    issuedAt
    validTo
    suklId
    doctor {
        titleBeforeName
        name
        surname
        titleAfterName
        email
    }
    medications {
        code
    }
    magistraliter {
        name
        amount
    }
    work {
        id
        workType
        dateFrom
        serviceId
    }
`;
